import { Link } from "react-router-dom";
import { WhatsappLogo, Phone, EnvelopeSimple, MapPin, InstagramLogo, FacebookLogo, YoutubeLogo } from "@phosphor-icons/react";
import { BRAND, ADDRESSES, whatsappLink, telLink } from "@/lib/data";

const MAIN_SERVICES = [
  "Aluminium Windows & Doors",
  "Architectural Glass",
  "Shower Enclosures",
  "Glass Partitions",
  "Glass Railings",
  "Glass Storefronts",
];

const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/projects", label: "Projects" },
  { to: "/contact", label: "Contact" },
];

const Footer = () => (
  <footer data-testid="site-footer" className="bg-ink text-offwhite">
    <div className="mx-auto max-w-[1400px] px-5 py-20 md:px-8 md:py-24">
      <div className="grid grid-cols-1 gap-14 md:grid-cols-12">
        <div className="md:col-span-4">
          <div className="flex items-center gap-3">
            <img src={BRAND.logo} alt="Nagar Glass" className="h-12 w-12 object-contain brightness-0 invert" />
            <div>
              <div className="font-display text-2xl font-semibold">Nagar Glass</div>
              <div className="text-[0.65rem] uppercase tracking-[0.2em] text-white/50">Glass & Aluminium · Ahmedabad</div>
            </div>
          </div>
          <p className="mt-7 max-w-sm text-sm leading-relaxed text-white/60">
            Custom glass and aluminium solutions for homes, offices, retail spaces and commercial
            projects across Ahmedabad. Built with clarity, designed to last — for over 15 years.
          </p>
          <a
            href={whatsappLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-btn"
            className="mt-7 inline-flex items-center gap-2.5 rounded-sm bg-offwhite px-6 py-3.5 text-xs font-semibold uppercase tracking-[0.14em] text-ink transition-colors hover:bg-gold"
          >
            <WhatsappLogo weight="fill" size={16} /> WhatsApp Us
          </a>
          <div className="mt-6 flex items-center gap-3">
            <a aria-label="Instagram" href="#" className="flex h-9 w-9 items-center justify-center rounded-full border border-white/20 text-white/70 hover:border-gold hover:text-gold">
              <InstagramLogo size={16} />
            </a>
            <a aria-label="Facebook" href="#" className="flex h-9 w-9 items-center justify-center rounded-full border border-white/20 text-white/70 hover:border-gold hover:text-gold">
              <FacebookLogo size={16} />
            </a>
            <a aria-label="YouTube" href="#" className="flex h-9 w-9 items-center justify-center rounded-full border border-white/20 text-white/70 hover:border-gold hover:text-gold">
              <YoutubeLogo size={16} />
            </a>
          </div>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-gold">Menu</h4>
          <ul className="mt-5 space-y-3">
            {NAV.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="text-sm text-white/70 transition-colors hover:text-white">
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-gold">Services</h4>
          <ul className="mt-5 space-y-3">
            {MAIN_SERVICES.map((s) => (
              <li key={s}>
                <Link to="/services" className="text-sm text-white/70 transition-colors hover:text-white">
                  {s}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-gold">Contact</h4>
          <div className="mt-5 space-y-4">
            <a href={telLink()} className="flex items-center gap-3 text-sm text-white/80 hover:text-white">
              <Phone weight="fill" size={15} /> {BRAND.phoneDisplay}
            </a>
            <a href={`mailto:${BRAND.email}`} className="flex items-center gap-3 text-sm text-white/80 hover:text-white">
              <EnvelopeSimple size={15} /> {BRAND.email}
            </a>
            {ADDRESSES.map((a) => (
              <div key={a.label} className="flex gap-3 text-xs leading-relaxed text-white/55">
                <MapPin size={15} className="mt-0.5 shrink-0 text-gold" />
                <span>{a.lines}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-7 md:flex-row md:items-center">
        <p className="text-xs text-white/40">© {new Date().getFullYear()} Nagar Glass · All rights reserved</p>
        <p className="text-xs text-white/40">Ahmedabad, Gujarat · India</p>
      </div>
    </div>
  </footer>
);

export default Footer;
